import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'

const firebaseConfig = {
    apiKey: "AIzaSyCyuPR3YMz-yu-2vuil8_rKR5iV9ijwdj0",
    authDomain: "rapida-schedule.firebaseapp.com",
    databaseURL: "https://rapida-schedule.firebaseio.com",
    projectId: "rapida-schedule",
    storageBucket: "rapida-schedule.appspot.com",
    messagingSenderId: "735545686579",
    appId: "1:735545686579:web:0c33a581c776a8fd8b8146",
    measurementId: "G-WG1VGKBV3D"
};

export const firebaseInstance = firebase
    .initializeApp(firebaseConfig);